import React from 'react';
import { useState, useEffect, useRef } from 'react';
import logo from './assets/logoBrain.svg';
import './App.css';
import { Link } from 'react-router-dom';
import Header from './Header/Header.js';
import Landing from './Landing/Landing.js';
import About from './About/About.js';
import ProjectSection from './Portfolio/ProjectSection.js';
import ExperienceSection from './Experience/ExperienceSection.js';
import Contact from './Contact/Contact.js';
import Footer from './Footer/Footer.js';
import ProjectModal from './Portfolio/ProjectModal.js';



function App() {

  const [activeSection, setActiveSection] = useState('home');
  const [modalProject, setModalProject] = useState(null);

  // Track active section on scroll
    useEffect(() => {
        const handleScroll = () => {
            const sections = document.querySelectorAll('section[id]');
            let current = '';
            
            sections.forEach(section => {
                const sectionTop = section.offsetTop - 100;
                if (window.scrollY >= sectionTop) {
                    current = section.getAttribute('id');
                }
            });
            
            setActiveSection(current);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  

  // Handle modal body scroll
    useEffect(() => {
        if (modalProject) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [modalProject]);

    const showProjectDetails = (projectId) => {
        setModalProject(projectId);
    };

    const closeModal = () => {
        setModalProject(null);
    };

  return (
    <div className="bg-gray-50 smooth-scroll">
      <Header activeSection={activeSection} setActiveSection={setActiveSection}/>
      <Landing />
      <About />
      <ProjectSection onShowProjectDetails={showProjectDetails} />
      <ExperienceSection />
      <Contact />
      <Footer />
      <ProjectModal 
        isOpen={!!modalProject}
        projectId={modalProject}
        onClose={closeModal}
      />
      {/* <h1 className="text-3xl font-bold underline">Testing Tailwind</h1> */}
    </div>
  );
}

export default App;
